import { firestore } from "../../../init/firebase";
import { Query, QueryDocumentSnapshot } from "../../../types/firebase.types";
import { AppResource } from "../../../types/resource.types";
import { roomMessagesSubCollRef } from "../../../utils/referencies";

const chatQueries = {
  baseListQuery(params: { userId: string; type: string; limit?: number }): Query {
    const { userId, type, limit = 10 } = params;
    return firestore
      .collection(AppResource.rooms)
      .where("participantType", "==", type)
      .where("disabled", "==", false)
      .where(AppResource.participants, "array-contains", userId)
      .limit(limit);
  },
  getChatRooms(params: { userId: string; type: string; limit?: number }): Query {
    const { userId, type, limit = 10 } = params;
    return this.baseListQuery({ userId, type, limit }).orderBy("lastMessage.createdAt", "desc");
  },
  getReceivedOneRoom(params: { userId: string; type: string }): Query {
    const { userId, type } = params;
    return this.baseListQuery({ userId, type, limit: 1 });
  },
  getReceivedOneUnseenRoom(params: { userId: string; type: any }): Query {
    const { userId, type } = params;
    return this.getReceivedOneRoom({ userId, type }).where(`seenBy.${userId}`, "==", false);
  },
  getRoomMessages(params: { roomId: string; limit?: number }): Query {
    const { roomId, limit = 20 } = params;
    return roomMessagesSubCollRef(roomId).orderBy("createdAt", "desc").limit(limit);
  },
  loadMoreRoomMessages(params: { startAfter: QueryDocumentSnapshot; roomId: string; limit?: number }): Query {
    const { startAfter, roomId, limit = 10 } = params;
    return this.getRoomMessages({ roomId, limit }).startAfter(startAfter);
  },
};

export default chatQueries;
